var exports = {
  "x": "x804f0401--fcb003--button",
};

module.exports = exports;
